import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { IUnsavedChangesConfirmationViewData } from './unsaved-changes-view-data';
import { ButtonDirective } from 'primeng/button';

@Component({
  selector: 'cmg-clear2-ui-unsaved-changes-confirmation',
  templateUrl: './unsaved-changes-confirmation.component.html',
  styleUrls: ['./unsaved-changes-confirmation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonDirective],
})
export class UnsavedChangesConfirmationComponent implements OnInit {
  private readonly _dialogRef = inject(DynamicDialogRef);
  private readonly _dynamicDialogConfig = inject(DynamicDialogConfig);

  message = `
  <p class="mt-0">Are you sure you want to leave the page without saving?</p>
  <p class="mt-0">All changes will be lost if they are not saved.</p>
  `;
  cancelButtonText = 'Continue without Saving';
  saveButtonText = 'Save and Continue';
  headerText = 'Unsaved Changes';

  ngOnInit(): void {
    if (this._dynamicDialogConfig.data?.viewData) {
      const viewData = <IUnsavedChangesConfirmationViewData>this._dynamicDialogConfig.data?.viewData;
      this.message = viewData.message;
      this.cancelButtonText = viewData.cancelButtonText;
      this.headerText = viewData.headerText;
      this.saveButtonText = viewData.saveButtonText;
    }
  }

  continueWithoutSaving(): void {
    this._dialogRef.close(false);
  }

  saveAndContinue(): void {
    this._dialogRef.close(true);
  }
}
